import React, { Fragment, useState } from 'react'
import { Dropdown, SplitButton, ButtonGroup } from 'react-bootstrap'
//import DropdownMultiselect from 'react-multiselect-dropdown-bootstrap'
import { Form } from 'react-bootstrap'
import avatar1 from '../../images/avatar/1.jpg'
import Shipping from '../Main/Frete'

import {BiStore} from 'react-icons/bi';
import {FaShippingFast} from 'react-icons/fa';
import {FiArrowLeftCircle, FiUser, FiMapPin} from 'react-icons/fi';

import {useHistory} from "react-router-dom";

import Stepper from "../../components/Stepper";

import buscarClientePorCpfLinx from '../../actions/cadastro/buscar-cliente-por-cpf-linx'

import { Box, Typography, TextField, Button, Avatar, Grid, Stack } from '@mui/material';


const inputSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 1.5,
    '&.Mui-focused fieldset': {
      borderColor: '#1a1a2e',
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#1a1a2e',
  },
};

const cardSx = {
  p: { xs: 2.5, md: 3 },
  borderRadius: 2.5,
  border: '1px solid',
  borderColor: 'grey.200',
  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
  bgcolor: '#fff',
};

const CadastroPage = () => {

  const [tipoEntrega, setTipoEntrega] = React.useState('');

  const [cpf, setCpf] = useState('');
  const [nomeCompleto, setNomeCompleto] = useState('');
  const [telefone, setTelefone] = useState('');
  const [email, setEmail] = useState('');
  const [cep, setCep] = useState('');
  const [rua, setRua] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [bairro, setBairro] = useState('');
  const [cidade, setCidade] = useState('');
  const [estado, setEstado] = useState('');


  const history = useHistory();

  const voltarPdv = () => {
   history.push('frete')
 }



  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Header */}
      <Box
        sx={{
          bgcolor: '#fff',
          borderBottom: '1px solid #e5e5e5',
          maxWidth: '98%',
          mx: 'auto',
          borderRadius: 2,
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          sx={{ py: 2, px: { xs: 2, md: 3 } }}
        >
          <Button
            onClick={voltarPdv}
            startIcon={<FiArrowLeftCircle size={24} />}
            sx={{
              bgcolor: '#1a1a2e',
              color: '#fff',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 1.5,
              '&:hover': { bgcolor: '#16213e' },
              px: 2.5,
            }}
          >
            Voltar
          </Button>
          <Box sx={{ flex: 1 }}>
            <Stepper valorStep={2} />
          </Box>
        </Stack>
      </Box>

      {/* Content */}
      <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3 }}>
        <Box sx={cardSx}>
          <form>
            {/* Section: Cadastro de Cliente */}
            <Box sx={{ mb: 3 }}>
              <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 3 }}>
                <Avatar
                  sx={{
                    width: 36,
                    height: 36,
                    bgcolor: '#e8eaf0',
                    color: '#1a1a2e',
                  }}
                >
                  <FiUser size={18} />
                </Avatar>
                <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
                  CADASTRO DE CLIENTE
                </Typography>
              </Stack>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="CPF"
                    placeholder="Digite o CPF"
                    value={cpf}
                    onChange={e => {
                      setCpf(e.target.value);
                      if(cpf.length >= 11) {
                        buscarClientePorCpfLinx(cpf).then(res => {

                          if(res.data.user){
                            setNomeCompleto(res.data.user.CLIENTE_VAREJO);
                            setTelefone(res.data.user.DDD_CELULAR+res.data.user.CELULAR);
                            setBairro(res.data.user.BAIRRO);
                            setRua(res.data.user.ENDERECO);
                            setEstado(res.data.user.UF);
                            setCep(res.data.user.CEP);
                            setNumero(res.data.user.NUMERO);
                            setCidade(res.data.user.CIDADE);
                            setComplemento(res.data.user.COMPLEMENTO);
                            setEmail(res.data.user.EMAIL);

                          } else {
                            alert('Esse ccpf não possui cadastro');
                          }

                        }).catch(err => console.log(err));
                      }
                    }}
                    sx={inputSx}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={8}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Nome"
                    placeholder="Digite seu nome completo"
                    value={nomeCompleto}
                    onChange={e => setNomeCompleto(e.target.value)}
                    sx={inputSx}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Whatsapp"
                    placeholder="Telefone"
                    value={telefone}
                    onChange={e => setTelefone(e.target.value)}
                    sx={inputSx}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Email"
                    placeholder="Email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    sx={inputSx}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Section: Informacoes Pessoais */}
            <Box sx={{ mb: 3 }}>
              <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 3 }}>
                <Avatar
                  sx={{
                    width: 36,
                    height: 36,
                    bgcolor: '#e8eaf0',
                    color: '#1a1a2e',
                  }}
                >
                  <FiMapPin size={18} />
                </Avatar>
                <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
                  INFORMAÇÕES PESSOAIS
                </Typography>
              </Stack>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={5}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="CEP"
                    placeholder="CEP"
                    value={cep}
                    onChange={e => setCep(e.target.value)}
                    sx={inputSx}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={5}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Rua"
                    placeholder="Rua"
                    value={rua}
                    onChange={e => setRua(e.target.value)}
                    sx={inputSx}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={2}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Número"
                    placeholder="Número"
                    value={numero}
                    onChange={e => setNumero(e.target.value)}
                    sx={inputSx}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Bairro"
                    placeholder="Bairro"
                    value={bairro}
                    onChange={e => setBairro(e.target.value)}
                    sx={inputSx}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={2}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Complemento"
                    placeholder="Complemento"
                    value={complemento}
                    onChange={e => setComplemento(e.target.value)}
                    sx={inputSx}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Cidade"
                    placeholder="Cidade"
                    value={cidade}
                    onChange={e => setCidade(e.target.value)}
                    sx={inputSx}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={2}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Estado"
                    placeholder="Estado"
                    value={estado}
                    onChange={e => setEstado(e.target.value)}
                    sx={inputSx}
                  />
                </Grid>
              </Grid>
            </Box>
          </form>
        </Box>
      </Box>
    </Box>
  )
}

export default CadastroPage;
